import { useQuery } from '@tanstack/react-query';
import type { ApiError } from '@/lib/api/client';
import { fetchTask } from '@/services/taskService';
import { queryKeys } from '@/lib/query/queryClient';
import type { Task } from '@/types/api';

/**
 * The card behind ?task=<id> when the board has not loaded it.
 *
 * Opening a notification for something on page four — or in a column you never
 * scrolled — has to work, and the board legitimately does not hold every card. This is
 * the fallback, and it is `enabled` only when the board came up empty, so the normal
 * path still costs nothing.
 */
export function useTaskById(taskId: string | null) {
  return useQuery<Task, ApiError>({
    queryKey: queryKeys.task(taskId ?? 'none'),
    queryFn: () => fetchTask(taskId as string),
    enabled: taskId !== null,
  });
}
